(function () {
  function fmt(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100);
  }
  function init(root) {
    var tiers = root.dataset.tiers.split(',').map(Number);
    var prefix = root.dataset.codePrefix;
    var items = [].slice.call(root.querySelectorAll('[data-fbt-item]'));
    var q = function (s) { return root.querySelector(s); };
    function variantEl(it) { return it.querySelector('[data-fbt-variant]'); }
    function price(it) {
      var el = variantEl(it);
      var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
      return Number(opt.dataset.price);
    }
    function pct(n) { return n >= 2 ? (tiers[Math.min(n, 5) - 2] || 0) : 0; }
    function update() {
      var on = items.filter(function (it) { return it.querySelector('[data-fbt-check]').checked; });
      items.forEach(function (it) {
        it.classList.toggle('is-off', !it.querySelector('[data-fbt-check]').checked);
        it.querySelector('[data-fbt-price]').textContent = fmt(price(it));
      });
      var sub = on.reduce(function (s, it) { return s + price(it); }, 0);
      var p = pct(on.length);
      var save = Math.round(sub * p / 100);
      q('[data-fbt-count]').textContent = on.length + (on.length === 1 ? ' item selected' : ' items selected');
      q('[data-fbt-before]').textContent = fmt(sub);
      q('[data-fbt-total]').textContent = fmt(sub - save);
      q('[data-fbt-save-row]').hidden = !p;
      q('[data-fbt-tier]').textContent = p ? 'Bundle savings (' + p + '% off)' : '';
      q('[data-fbt-save]').textContent = p ? '-' + fmt(save) : '';
      var next = null;
      for (var n = on.length + 1; n <= 5; n++) { if (pct(n) > p && n <= items.length) { next = n; break; } }
      q('[data-fbt-hint]').textContent = next ? 'Add ' + (next - on.length) + ' more for ' + pct(next) + '% off.' : (p ? 'Discount applies at checkout.' : '');
      q('[data-fbt-add]').disabled = on.length === 0;
      return { on: on, pct: p };
    }
    root.addEventListener('change', update);
    q('[data-fbt-add]').addEventListener('click', function () {
      var btn = this, st = update();
      var err = q('[data-fbt-error]');
      err.textContent = '';
      btn.disabled = true;
      var lines = st.on.map(function (it) { return { id: Number(variantEl(it).value), quantity: 1 }; });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          var code = st.pct && st.on.length > 1 ? prefix + '-' + Math.min(st.on.length, 5) : null;
          return code ? fetch('/discount/' + code, { credentials: 'same-origin' }).catch(function () {}) : null;
        })
        .then(function () {
          return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
        })
        .then(function (s) {
          var drawer = document.querySelector('cart-drawer');
          var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var inner = doc.querySelector('.drawer__inner'), cur = document.querySelector('#CartDrawer .drawer__inner');
          if (inner && cur) cur.innerHTML = inner.innerHTML;
          var bub = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var tgt = document.getElementById('cart-icon-bubble');
          if (bub && tgt) tgt.innerHTML = bub.innerHTML;
          if (drawer) { drawer.classList.remove('is-empty'); drawer.open(); } else { window.location = '/cart'; }
        })
        .catch(function () { err.textContent = 'Could not add the bundle. Please try again.'; })
        .then(function () { btn.disabled = false; });
    });
    update();
  }
  document.querySelectorAll('[data-cedar-fbt]').forEach(init);
})();
